export default "__VITE_ASSET__CKz$tOoU__"